import { render } from "./TemplateThirteen.vue?vue&type=template&id=7933afaa"
import script from "./TemplateThirteen.vue?vue&type=script&lang=js"
export * from "./TemplateThirteen.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__